import PeriodMetrics from '@/components/kpi/period-metrics/PeriodMetrics.vue';
import KpiPeriodEdit from '@/components/kpi/period-results/period-edit/KpiPeriodEdit.vue';
import TableviewExtended from '@/components/common/TableviewExtended/TableviewExtended.vue';

const item = {
  payout: null,
  status_id: null,
  valuation: null
}

export default {
  name: 'PeriodResults',
  components: { TableviewExtended, KpiPeriodEdit, PeriodMetrics },
  data () {
    return {
      isMounted: false,
      isLoading: false,
      paging: {
        page: 1,
        pages: 1,
        limit: 10,
        total: 0
      },
      tableSorting: { item: 'title', direction: 'asc' },
      filterValues: {
        title: null
      },
      tableItems: [{ ...item }]
    }
  },
  props: {
    data: {
      default: null,
      type: Object
    },
    mode: {
      default: null,
      type: String
    },
    canEditRow: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    isBaseDataFilled () {
      return this.data.user_kpi_data && this.data.user_kpi_data.salary && this.data.user_kpi_data.salary &&
        this.data.user_kpi_data.kpi_bonus_rate && this.data.user_kpi_data.period_type;
    },
    getStatus () {
      return 'xxx';
    },
    userCompanyJobPositionId () {
      return this.data?.id;
    },
    canEdit () {
      if (!this.canEditRow) {
        return false;
      }
      if (this.mode === 'mykpi') {
        return false;
      }
      return true;
    },
    tableExpandConfig () {
      return { component: 'slot' };
    },
    requestPath () {
      const path = `kpi/user-company-job-positions/${this.data.id}/results?mode=` + this.mode + '&perPage=' + this.paging.limit + '&page=' + this.paging.page;
      return this.ApiRequest.addGetParamsToPath(
        path,
        (this.$refs.tableview ? this.$refs.tableview.getFilterValues() : this.filterValues),
        true
      );
    },
    tableHeaders () {
      const headers = [
        { key: 'created_at', label: this.$t('kpi.created_at'), class: 'col-width-xl', type: 'date' },
        { key: 'period_id', label: this.$t('kpi.period'), class: 'col-width-xl', format: 'formatFromConfig', configKey: 'periods', configParam: 'name' },
        { key: 'salary', label: this.$t('kpi.salary'), class: 'col-width-xl' },
        { key: 'max_payout', label: this.$t('kpi.max_payout'), class: 'col-width-xl' },
        { key: 'valuation', label: this.$t('kpi.valuation'), class: 'col-width-xl' },
        { key: 'status_id', label: this.$t('general.status'), class: 'col-width-xl', format: 'formatFromConfig', configKey: 'kpi_result_statuses', configParam: 'name' },
        { key: 'payout', label: this.$t('kpi.payout'), class: 'col-width-xl' }
      ];

      const actions = [];
      if (this.canEdit) {
        actions.push({ label: this.$t('general.actions.delete'), emit: 'deleteItem', bicon: 'trash', class: 'btn-danger btn-sm', ifconfig: { useFunc: true, func: this.canEditPeriod } });
      }
      headers.push({ key: 'actions', label: '', actions: actions, headerClass: 'col-1' });

      return headers;
    },
    tableActions () {
      const actions = { download: false };
      if (this.canEdit && this.isBaseDataFilled) {
        actions.add = { title: this.$t('general.actions.create-new') };
      }
      return actions;
    },
    tableFilterConfig () {
      const filters = {};
      filters.title = { type: 'text', label: 'title', colOnlyFilter: true };
      filters.published_at = { type: 'checkbox', label: 'published_at', options: this.yesNoOptions, colOnlyFilter: true };
      return filters;
    }
  },
  methods: {
    updateFilters () {
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      this.getTableData();
    },
    deleteItem (el) {
      this.isUpdating = true;
      this.currentReq = this.ApiRequest.request(`kpi/user-company-job-positions/${this.data.id}/results/${el.id}/`, this.ApiRequest.REQUEST_DELETE, [], (response) => {
        if (!response.error && response.data) {
          this.tableItems.splice(parseInt(el.itemIndex), 1);
        } else {
          this.$store.commit('toastAdd', {
            context: 'danger',
            message: this.$t('Neizdevās izdzēst')
          });
        }
      });
      this.isUpdating = false;
    },
    canEditPeriod (row) {
      return row.is_edit_enabled || !row.id;
    },
    updateKpiPeriod (el) {
      el.is_edit_enabled = true;
      this.tableItems.unshift(el);
    },
    updateResult (event) {
      const row = this.tableItems.find(el => el.id === event.id);
      row.payout = event.payout;
      row.valuation = event.valuation;
      row.status_id = event.status_id;
      this.$set(row, 'status_id', event.status_id);
      this.$set(row, 'payout', event.payout);
      this.$set(row, 'valuation', event.valuation);
    },
    addItem (el) {
      this.$refs.editElFrm.show(this.data);
    },
    getTableData () {
      this.isLoading = false;
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.isLoading = true;
      this.$forceUpdate();
      this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, [], (response) => {
        if (response.data) {
          this.tableItems = response.data;
          this.paging = response.paging;
          this.isLoading = false;
        }
      });
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    }
  },
  mounted () {
    this.getTableData();
    this.isMounted = true;
  }
}
